import { Tag } from 'primereact/tag';
import { scheduleStateOf, SCHEDULE_STATE_PRESENTATION } from '../../utils/schedule-state';

/** One tag for a schedule's real state — see utils/schedule-state. */
const ScheduleStateTag = (
  { schedule, showHint = false }:
  { schedule: { isActive?: boolean | null; isScheduleEnabled?: boolean }; showHint?: boolean },
) => {
  const { label, severity, hint } = SCHEDULE_STATE_PRESENTATION[scheduleStateOf(schedule)];
  return (
    <span className="inline-flex flex-col">
      <Tag value={label} severity={severity} className="text-xs px-1.5 py-0.5" />
      {showHint ? <span className="text-xs text-gray-400 mt-0.5">{hint}</span> : null}
    </span>
  );
};

export default ScheduleStateTag;
